import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetDictionaryCommand } from '@/app/dictionary/commands/get-dictionary.command'

const httpClient = new AxiosClient()

export const getDictionaryCommand = new GetDictionaryCommand(httpClient, store)
